import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CodeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"code"}/>
}
